import React, { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  Card,
  Divider,
  Button,
  Row,
  Col,
  Space,
  Input,
  Table,
  message,
  Spin,
  Modal,
  Tag,
} from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { BASE_URL_BEN } from "../../API/apiUrls";

const Main = () => {
  const tk = localStorage.getItem("TOKEN");

  const [isClicked, setIsClicked] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]); // เก็บข้อมูลจาก API
  const [loading, setLoading] = useState(false);

  const currencyFormatOne = (amount) => {
    if (amount) {
      return Number(amount)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return "0.00";
    }
  };
  // ฟังก์ชันล้างค่าทั้งหมด (ใช้ตอนสลับปุ่ม)
  const resetAll = (type) => {
    setIsClicked(type);
    // setSearchText("");
    setDataSource([]);
  };

  // ฟังก์ชันค้นหาข้อมูล
  const handleSearch = async () => {
    console.log("handleSearch");
    setLoading(true);
    try {
      const finalPayload = {
        CONTNO: searchText,
        cancelType: isClicked,
      };

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/main-cancel-payment`,
        finalPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );

      console.log(response);
      if (response.data) {
        setDataSource(response.data);
      } else {
        setDataSource([]);
        message.info("ไม่พบข้อมูล");
      }
    } catch (error) {
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async (record) => {
    console.log("handleCancel for:", record);
    Modal.confirm({
      title: "ยืนยันการยกเลิก",
      content: `คุณต้องการยกเลิกใบเสร็จ ${record?.TMBILL} ใช่หรือไม่?`,
      okText: "ยืนยันยกเลิก",
      okType: "danger",
      cancelText: "ย้อนกลับ",
      onOk: async () => {
        if (isClicked === 2) {
          console.log("ยกเลิกลูกหนี้");
          setLoading(true);
          try {
            const response = await axios.post(
              `${BASE_URL_BEN}/auth/enter-cancel-arothr`,
              record,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tk}`,
                },
              },
            );

            if (response.data) {
              message.success("ทำรายการสำเร็จ");
              handleSearch();
            } else {
              message.info("ไม่พบข้อมูล");
            }
          } catch (error) {
            message.error("เกิดข้อผิดพลาดในการยกเลิก");
          } finally {
            setLoading(false);
          }
        } else if (isClicked === 1) {
          console.log("ยกเลิกปกติ");
          setLoading(true);
          try {
            const response = await axios.post(
              `${BASE_URL_BEN}/auth/enter-cancel-payment`,
              record,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tk}`,
                },
              },
            );

            if (response.data) {
              message.success("ทำรายการสำเร็จ");
              handleSearch();
            } else {
              message.info("ไม่พบข้อมูล");
            }
          } catch (error) {
            message.error("เกิดข้อผิดพลาดในการยกเลิก");
          } finally {
            setLoading(false);
          }
        } else {
          message.error("ไม่เข้าเงื่อนไขยกเลิก");
        }
      },
      onCancel() {
        console.log("User กดยกเลิก");
      },
    });
  };

  // กำหนด Column ของ Table
  const columns = [
    {
      title: "เลขที่ใบเสร็จ",
      dataIndex: "TMBILL",
      key: "TMBILL",
      width: 80,
      align: "center",
    },
    {
      title: "วันที่ใบเสร็จ",
      dataIndex: "TMBILDT",
      key: "TMBILDT",
      align: "center",
      render: (text) => {
        // ตรวจสอบก่อนว่ามีข้อมูลวันที่ส่งมาหรือไม่
        return text ? dayjs(text).format("YYYY-MM-DD") : "-";
      },
    },
    { title: "ชำระด้วย", dataIndex: "PAYTYP", key: "PAYTYP", align: "center" },
    {
      title: "จำนวนเงิน",
      dataIndex: "CHQAMT",
      key: "CHQAMT",
      align: "center",
      render: (text) => currencyFormatOne(text),
    },
    { title: "สถานะ", dataIndex: "FLAG", key: "FLAG", align: "center" },
    {
      title: "วันที่ยกเลิกใบเสร็จ",
      dataIndex: "CANDT",
      key: "CANDT",
      align: "center",
      render: (text) => {
        // ตรวจสอบก่อนว่ามีข้อมูลวันที่ส่งมาหรือไม่
        return text ? dayjs(text).format("YYYY-MM-DD") : "-";
      },
    },
    {
      title: "ผู้อนุมัติ",
      key: "user_display", // เปลี่ยน key ให้สื่อความหมายเพราะเป็นการรวมฟิลด์
      align: "center",
      render: (_, record) => {
        return (
          <Tag color="green">
            {" "}
            {record.CANDT ? record.CANDT_BY : record.INPUT_BY}
          </Tag>
        );
      },
    },
    {
      title: "การจัดการ",
      key: "action",
      align: "center",
      render: (_, record) => {
        // 👇 เพิ่มเงื่อนไขใหม่: ผ่อนแบบตาราง
        if (record.flag_due === 1 && record.PAYDT && record.flag_due_date) {
          // ตัด String เอาแค่ 10 ตัวแรก (YYYY-MM-DD) มาเทียบกัน
          const payDateOnly = record.PAYDT.substring(0, 10);
          const flagDueDateOnly = record.flag_due_date.substring(0, 10);

          if (payDateOnly <= flagDueDateOnly) {
            return (
              <b style={{ color: "red" }}>
                ไม่สามารถยกเลิกได้ <br />
                เนื่องจากเป็นเงื่อนไขในการผ่อนแบบตาราง
              </b>
            );
          }
        }

        // เงื่อนไข: ยกเลิกไปแล้ว
        if (record.CANDT || record.FLAG === "C") {
          return (
            <b style={{ color: "gray" }}>
              ยกเลิกแล้วเมื่อ {dayjs(record.CANDT).format("YYYY-MM-DD")}
            </b>
          );
        }

        // เงื่อนไข: ส่งบัญชีไปแล้ว
        if (record.POSTGL === "Y") {
          return <b style={{ color: "red" }}>ติดต่อบัญชี (Post แล้ว)</b>;
        }

        // เงื่อนไข: ต้องยกเลิกบิลล่าสุดก่อน
        if (isClicked === 1 && record?.OK_CANCEL === 0) {
          return <b style={{ color: "red" }}>ต้องยกเลิกบิลล่าสุดก่อน</b>;
        }

        // เงื่อนไข: มีการรับเข้าค่าแทนฯ
        if (isClicked === 2 && record?.OK_CANCEL === 0) {
          return (
            <b style={{ color: "red" }}>
              ไม่สามารถยกเลิกได้ <br />
              เนื่องจากมีการรับเข้าค่าแทนหรือขาดประโยชน์แล้ว
            </b>
          );
        }

        // สุดท้าย: ถ้าไม่ติดเงื่อนไขข้างบนเลย ให้โชว์ปุ่มปกติ
        return (
          <Button
            type="primary"
            danger // ใส่สีแดงเพื่อให้รู้ว่าเป็นปุ่มลบ/ยกเลิก
            icon={<CloseOutlined />} // 💡 แนะนำ: ถ้าปุ่มคือยกเลิก อาจจะเปลี่ยนไอคอนเป็น <DeleteOutlined /> หรือ <CloseCircleOutlined /> จะสื่อความหมายกว่านะครับ
            onClick={() => handleCancel(record)}
          >
            ยกเลิกใบเสร็จ
          </Button>
        );
      },
    },
  ];
  return (
    <Card>
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Divider orientation={"center"}>
          <b>
            <u>สลับรายการ ยกเลิกใบเสร็จ รับเงิน ทนาย</u>
          </b>
        </Divider>
        <Row justify="center" style={{ marginBottom: 20 }}>
          <Col>
            <Space>
              <Button
                onClick={() => resetAll(1)}
                style={{
                  background: isClicked === 1 ? "#ffcb05" : "white",
                  fontWeight: isClicked === 1 ? "bold" : "normal",
                  borderColor: isClicked === 1 ? "#efa420" : "white",
                }}
              >
                ยกเลิกใบเสร็จ ปกติ
              </Button>
              <Button
                onClick={() => resetAll(2)}
                style={{
                  background: isClicked === 2 ? "#ffcb05" : "white",
                  borderColor: isClicked === 2 ? "#efa420" : "white",
                  fontWeight: isClicked === 2 ? "bold" : "normal",
                }}
              >
                ยกเลิกใบเสร็จ ลูกหนี้อื่นๆ
              </Button>
            </Space>
          </Col>
        </Row>

        {/* ส่วนของการค้นหา */}
        <Row justify="center" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Space.Compact style={{ width: "100%" }}>
              <Input
                placeholder={
                  isClicked === 1
                    ? "ค้นหารายการปกติ..."
                    : "ค้นหาลูกหนี้อื่นๆ..."
                }
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onPressEnter={handleSearch}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
                style={{
                  backgroundColor: "#efa420",
                  borderColor: "#efa420",
                  color: "#fff",
                }}
                loading={loading}
              >
                ค้นหา
              </Button>
            </Space.Compact>
          </Col>
        </Row>

        {/* ส่วนแสดงตารางข้อมูล */}
        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey="TMBILL"
          loading={loading}
          locale={{ emptyText: "ไม่มีข้อมูลรายการ" }}
        />
      </Spin>
    </Card>
  );
};

const MainCancelReceivePayment = MotionHoc(Main);
export default MainCancelReceivePayment;
